export { OutletFooter } from './outlet-footer';
